import { render, staticRenderFns } from "./ValidationTable.vue?vue&type=template&id=48b1818e&scoped=true"
import script from "./ValidationTable.vue?vue&type=script&lang=ts"
export * from "./ValidationTable.vue?vue&type=script&lang=ts"
import style0 from "./ValidationTable.vue?vue&type=style&index=0&id=48b1818e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1818e",
  null
  
)

export default component.exports